<mat-card-content>
  <div class="ps-grid-4-col">
    <div *ngIf="!mobile"></div>
    <div *ngIf="!mobile">{{_previousStatus?.TIMELABEL}}</div>
    <div></div>
    <div>{{_previousStatus?.TIMELABEL}}</div>

    <mat-form-field>
      <mat-label>Datum WZA erhalten</mat-label>
      <input matInput [matDatepicker]="pickerLastETA" [(ngModel)]="_currentStatus.DATE_LAST_ETA"
             (ngModelChange)="onChange()" disabled>
      <mat-datepicker-toggle matSuffix [for]="pickerLastETA">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerLastETA [disabled]="!editable"></mat-datepicker>
    </mat-form-field>

    <div *ngIf="_previousStatus"
         [ngClass]="{'different' : isDifferent(_previousStatus.DATE_LAST_ETA, _currentStatus.DATE_LAST_ETA)}">
      {{_previousStatus.DATE_LAST_ETA | date}}
    </div>
    <div *ngIf="!_previousStatus">
      Noch kein Wert gesetzt!
    </div>

    <mat-form-field>
      <mat-label>Werkzeugart</mat-label>
      <mat-select [disabled]="!editable" [compareWith]="compareObjects" (ngModelChange)="onChange()"
                  [(ngModel)]="_currentStatus.LINK_PSE_WERKZEUGART_ID">
        <mat-option *ngFor="let type of typeObjects" [value]="type.OBJECT_ID">
          {{type.NAME}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div *ngIf="_previousStatus"
         [ngClass]="{'different' : isDifferent(_previousStatus.LINK_PSE_WERKZEUGART_ID, _currentStatus.LINK_PSE_WERKZEUGART_ID)}">
      {{_previousStatus?.LINK_PSE_WERKZEUGART_ID}}
    </div>
    <div *ngIf="!_previousStatus">
      Noch kein Wert gesetzt!
    </div>

    <mat-form-field>
      <mat-label>Status Konstruktion</mat-label>
      <mat-select [disabled]="!editable" [compareWith]="compareObjects" (ngModelChange)="onChange()"
                  [(ngModel)]="_currentStatus.LINK_PSE_KONSTRUKTION_STATUS_ID">
        <mat-option *ngFor="let status of statusObjects" [value]="status.OBJECT_ID">
          {{status.DESCRIPTION}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div *ngIf="_previousStatus"
         [ngClass]="{'different' : isDifferent(_previousStatus.LINK_PSE_KONSTRUKTION_STATUS_ID, _currentStatus.LINK_PSE_KONSTRUKTION_STATUS_ID)}">
      {{_previousStatus?.LINK_PSE_KONSTRUKTION_STATUS_ID}}
    </div>
    <div *ngIf="!_previousStatus">
      Noch kein Wert gesetzt!
    </div>

    <mat-form-field>
      <mat-label>Datum Blecheingang</mat-label>
      <input matInput [matDatepicker]="pickerMatReceipt" [(ngModel)]="_currentStatus.DATE_MAT_RECEIPT"
             (ngModelChange)="onChange()" disabled>
      <mat-datepicker-toggle matSuffix [for]="pickerMatReceipt">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerMatReceipt [disabled]="!editable"></mat-datepicker>
    </mat-form-field>

    <div *ngIf="_previousStatus"
         [ngClass]="{'different' : isDifferent(_previousStatus?.DATE_MAT_RECEIPT, _currentStatus.DATE_MAT_RECEIPT)}">
      {{_previousStatus?.DATE_MAT_RECEIPT | date}}
    </div>
    <div *ngIf="!_previousStatus">
      Noch kein Wert gesetzt!
    </div>

    <mat-form-field>
      <mat-label>Programmierung fertig</mat-label>
      <input matInput [matDatepicker]="pickerCadFinished" [(ngModel)]="_currentStatus.DATE_CAD_FINISHED"
             (ngModelChange)="onChange()" disabled>
      <mat-datepicker-toggle matSuffix [for]="pickerCadFinished">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerCadFinished [disabled]="!editable"></mat-datepicker>
    </mat-form-field>

    <div *ngIf="_previousStatus"
         [ngClass]="{'different' : isDifferent(_previousStatus.DATE_CAD_FINISHED, _currentStatus.DATE_CAD_FINISHED)}">
      {{_previousStatus?.DATE_CAD_FINISHED | date}}
    </div>
    <div *ngIf="!_previousStatus">
      Noch kein Wert gesetzt!
    </div>

    <mat-form-field>
      <mat-label>Guss / Stahl Eingang</mat-label>
      <input matInput [matDatepicker]="pickerLastOp" [(ngModel)]="_currentStatus.DATE_CAST_LAST_OP"
             (ngModelChange)="onChange()" disabled>
      <mat-datepicker-toggle matSuffix [for]="pickerLastOp">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerLastOp [disabled]="!editable"></mat-datepicker>
    </mat-form-field>

    <div *ngIf="_previousStatus"
         [ngClass]="{'different' : isDifferent(_previousStatus.DATE_CAST_LAST_OP, _currentStatus.DATE_CAST_LAST_OP)}">
      {{_previousStatus?.DATE_CAST_LAST_OP | date}}
    </div>
    <div *ngIf="!_previousStatus">
      Noch kein Wert gesetzt!
    </div>

    <mat-form-field>
      <mat-label>Start Fräsen</mat-label>
      <input matInput [matDatepicker]="pickerMillingFirstOp" [(ngModel)]="_currentStatus.DATE_DIE_MIILING_FIRST_OP"
             (ngModelChange)="onChange()" disabled>
      <mat-datepicker-toggle matSuffix [for]="pickerMillingFirstOp">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerMillingFirstOp [disabled]="!editable"></mat-datepicker>
    </mat-form-field>

    <div *ngIf="_previousStatus"
         [ngClass]="{'different' : isDifferent(_previousStatus.DATE_DIE_MIILING_FIRST_OP, _currentStatus.DATE_DIE_MIILING_FIRST_OP)}">
      {{_previousStatus?.DATE_DIE_MIILING_FIRST_OP | date}}
    </div>
    <div *ngIf="!_previousStatus">
      Noch kein Wert gesetzt!
    </div>

    <mat-form-field>
      <mat-label>Ende Fräsen</mat-label>
      <input matInput [matDatepicker]="pickerMillingLastOp" [(ngModel)]="_currentStatus.DATE_DIE_MIILING_LAST_OP"
             (ngModelChange)="onChange()" disabled>
      <mat-datepicker-toggle matSuffix [for]="pickerMillingLastOp">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerMillingLastOp [disabled]="!editable"></mat-datepicker>
    </mat-form-field>

    <div *ngIf="_previousStatus"
         [ngClass]="{'different' : isDifferent(_previousStatus.DATE_DIE_MIILING_LAST_OP, _currentStatus.DATE_DIE_MIILING_LAST_OP)}">
      {{_previousStatus?.DATE_DIE_MIILING_LAST_OP | date}}
    </div>
    <div *ngIf="!_previousStatus">
      Noch kein Wert gesetzt!
    </div>

    <mat-form-field>
      <mat-label>Werkzeug finish</mat-label>
      <input matInput [matDatepicker]="pickerAssemblyFirstOp" [(ngModel)]="_currentStatus.DATE_DIE_ASSEMBLY_FIRST_OP"
             (ngModelChange)="onChange()" disabled>
      <mat-datepicker-toggle matSuffix [for]="pickerAssemblyFirstOp">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerAssemblyFirstOp [disabled]="!editable"></mat-datepicker>
    </mat-form-field>

    <div *ngIf="_previousStatus"
         [ngClass]="{'different' : isDifferent(_previousStatus.DATE_DIE_ASSEMBLY_FIRST_OP, _currentStatus.DATE_DIE_ASSEMBLY_FIRST_OP)}">
      {{_previousStatus?.DATE_DIE_ASSEMBLY_FIRST_OP | date}}
    </div>
    <div *ngIf="!_previousStatus">
      Noch kein Wert gesetzt!
    </div>

    <mat-form-field>
      <mat-label>Letzte Formänderung</mat-label>
      <input matInput [matDatepicker]="pickerLastChange" [(ngModel)]="_currentStatus.DATE_LAST_CHANGE"
             (ngModelChange)="onChange()" disabled>
      <mat-datepicker-toggle matSuffix [for]="pickerLastChange">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerLastChange [disabled]="!editable"></mat-datepicker>
    </mat-form-field>

    <div *ngIf="_previousStatus"
         [ngClass]="{'different' : isDifferent(_previousStatus.DATE_LAST_CHANGE, _currentStatus.DATE_LAST_CHANGE)}">
      {{_previousStatus?.DATE_LAST_CHANGE | date}}
    </div>
    <div *ngIf="!_previousStatus">
      Noch kein Wert gesetzt!
    </div>

    <mat-form-field>
      <mat-label>Werkzeug Liefertermin</mat-label>
      <input matInput [matDatepicker]="pickerDelivery" [(ngModel)]="_currentStatus.DATE_DELIVERY"
             (ngModelChange)="onChange()" disabled>
      <mat-datepicker-toggle matSuffix [for]="pickerDelivery">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerDelivery [disabled]="!editable"></mat-datepicker>
    </mat-form-field>

    <div *ngIf="_previousStatus"
         [ngClass]="{'different' : isDifferent(_previousStatus.DATE_DELIVERY, _currentStatus.DATE_DELIVERY)}">
      {{_previousStatus?.DATE_DELIVERY | date}}
    </div>
    <div *ngIf="!_previousStatus">
      Noch kein Wert gesetzt!
    </div>

    <mat-form-field>
      <mat-label>Kommentar</mat-label>
      <input matInput [disabled]="!editable" [(ngModel)]="_currentStatus.TEXT_COMMENT" (ngModelChange)="onChange()">
    </mat-form-field>

    <div *ngIf="_previousStatus"
         [ngClass]="{'different' : isDifferent(_previousStatus.TEXT_COMMENT, _currentStatus.TEXT_COMMENT)}">
      {{_previousStatus?.TEXT_COMMENT}}
    </div>
    <div *ngIf="!_previousStatus">
      Noch kein Wert gesetzt!
    </div>

  </div>

</mat-card-content>

